import { Col } from 'antd';
import parse from 'html-react-parser';
import React from 'react';

type Props = {
    name: string | undefined;
    value: string | undefined;
    index: number;
};

const InfoView: React.FC<Props> = ({ name, value, index }) => {
    return (
        <Col xs={24} md={12} key={`${name}_${index}_${value}`}>
            <p className="text-[12px] text-[#747474] WorkSans">{name}</p>
            <p className="text-[#20222B] font-bold text-sm WorkSans">{parse(value || '')}</p>
        </Col>
    );
};

export default InfoView;
